<template>
  <div class="sections-container">
    <div class="background-mosaic"></div>
    <img src="@/assets/flor.svg" class="flor-top-left" alt="" />
    <img src="@/assets/flor.svg" class="flor-bottom-right" alt="" />

    <div class="content-wrapper">
      <h2 class="title">Conoce todas nuestras<br />líneas de productos:</h2>
      <div class="sections-grid">
        <div class="merheje">
          <router-link to="/merheje">
            <img
              src="@/assets/merheje-logo.svg"
              alt="Merheje Logo"
              class="logo"
            />
          </router-link>
        </div>
        <div class="unhex">
          <router-link to="/unhex">
            <img src="@/assets/unhex-logo.svg" alt="Unhex Logo" class="logo" />
          </router-link>
        </div>
        <div class="curvex">
          <router-link to="/curvex">
            <img
              src="@/assets/curvex-logo.svg"
              alt="Curvex Logo"
              class="logo"
            />
          </router-link>
        </div>
        <div class="donde-encontrarnos">
          <router-link to="/donde-encontrarnos" class="donde-link">
            <img
              src="@/assets/dondeencontrarnos.svg"
              alt="Donde Encontrarnos"
              class="logo"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sections-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #3b205e; /* base color in case pattern fails */
}

.background-mosaic {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/fondo_landing.webp");
  background-repeat: repeat;
  background-size: 800px;
  z-index: 0;
}

.flor-top-left {
  position: absolute;
  top: -10vw;
  left: -5vw;
  width: 40vw;
  max-width: 400px;
  min-width: 200px;
  z-index: 1;
  pointer-events: none;
}

.flor-bottom-right {
  position: absolute;
  bottom: -15vw;
  right: -5vw;
  width: 45vw;
  max-width: 450px;
  min-width: 250px;
  transform: rotate(180deg);
  z-index: 1;
  pointer-events: none;
}

.content-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding-top: 3rem;
  width: 100%;
  max-width: 600px;
}

.title {
  color: white;
  text-align: center;
  font-size: 2rem;
  font-family: "Omnes", sans-serif;
  margin: 0;
  line-height: 1.2;
}

.sections-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}

.sections-grid div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18rem;
  height: 7rem;
  border-radius: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.sections-grid div:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.sections-grid div a {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.merheje {
  background: #ffffff;
}
.merheje img {
  filter: none !important;
}

.unhex {
  background: #08245b;
}
.unhex img {
  filter: brightness(0) invert(1) !important;
}

.curvex {
  background: #fae100;
}
.curvex img {
  filter: brightness(0) !important;
}

.donde-encontrarnos {
  background: #da1884;
}
.donde-link {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.logo {
  max-width: 65%;
  max-height: 55%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: all 0.3s ease;
  display: block;
}

.donde-encontrarnos .logo {
  max-width: 95%;
  max-height: 85%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .title {
    font-size: 1.5rem;
  }
  .flor-top-left {
    width: 60vw;
    top: -15vw;
    left: -10vw;
  }
  .flor-bottom-right {
    width: 65vw;
    bottom: -20vw;
    right: -10vw;
  }
  .sections-grid div {
    width: 16rem;
    height: 6rem;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.25rem;
    padding: 0 1rem;
  }
  .flor-top-left {
    width: 80vw;
    top: -20vw;
    left: -15vw;
  }
  .flor-bottom-right {
    width: 85vw;
    bottom: -25vw;
    right: -15vw;
  }
  .sections-grid {
    gap: 1rem;
  }
  .sections-grid div {
    width: 14rem;
    height: 5.5rem;
    border-radius: 0.8rem;
  }
}
</style>
